import { apiRegistro, apiPesquisaSatisfacao } from '../../../../../plugins/axios'

export default {
  getUsers() {
    return apiRegistro().get('/user')
  },

  gerarAuditoria(form) {
    return apiPesquisaSatisfacao().post('/audit?_method=GET', form)
  },
}
